import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/carousel/styles.css';
import '@mantine/tiptap/styles.css';
import { MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { CookieConsentProvider } from './context/CookieConsentContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MantineProvider>
      <Notifications />
      <ModalsProvider>
        <CookieConsentProvider>
          <App />
        </CookieConsentProvider>
      </ModalsProvider>
    </MantineProvider>
  </React.StrictMode>
);
